import api from 'services/api'

/**
 * @deprecated This service/type is deprecated and should not be used in new features
 * Use the new services/types from `services/shared/customers`
 */
export const getClientOvTypes = async (clientId: string, officeId: string) => {
  const returnApi = await api
    .get(`/cliente/v2/tiposOrdemVendas`, {
      params: {
        clienteId: clientId,
        escritorioId: officeId,
      },
    })
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
  return returnApi
}
